import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectFilter from './SelectFilter';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';
import {
  clearTollLiquidationDifferenceReasons,
  getTollLiquidationDifferenceReasons,
} from '../../../actions/route/TollLiquidation';
import { DEFAULT_QUERY_GET_ALL } from '../../../config/queries';

class TollLiquidationDifferenceReasonFilter extends Component {
  componentDidMount() {
    const { dispatchGetTollLiquidationDifferenceReasons } = this.props;
    dispatchGetTollLiquidationDifferenceReasons({ ...DEFAULT_QUERY_GET_ALL });
  }

  componentWillUnmount() {
    const { dispatchClearTollLiquidationDifferenceReasons } = this.props;
    dispatchClearTollLiquidationDifferenceReasons();
  }

  userFilterOption = (options) => options;

  render() {
    const {
      reasons,
      onChangeFilter,
      isMulti,
      loading,
      isClearable,
      placeholder,
    } = this.props;

    return (
      <SelectFilter
        placeholder={placeholder}
        isMulti={isMulti}
        onChangeFilter={onChangeFilter}
        options={reasons}
        isLoading={loading}
        filterOption={this.userFilterOption}
        isClearable={isClearable}
      />
    );
  }
}

const mapStateToProps = ({ RouteUnit }) => ({
  reasons: RouteUnit.TollLiquidation.getIn([
    'differenceReason',
    'content',
    'content',
  ]).map((reason) => ({
    value: reason.id,
    label: reason.name,
    id: reason.id,
    name: reason.name,
  })),
  loading: RouteUnit.TollLiquidation.getIn(['differenceReason', 'loading']),
});

TollLiquidationDifferenceReasonFilter.propTypes = {
  dispatchGetTollLiquidationDifferenceReasons: PropTypes.func.isRequired,
  dispatchClearTollLiquidationDifferenceReasons: PropTypes.func.isRequired,
  reasons: optionsPropTypes,
  onChangeFilter: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

TollLiquidationDifferenceReasonFilter.defaultProps = {
  reasons: [],
  isMulti: false,
  loading: false,
  isClearable: false,
  placeholder: 'Seleccione motivo de diferencia',
};

const mapDispatchToProps = {
  dispatchGetTollLiquidationDifferenceReasons:
    getTollLiquidationDifferenceReasons,
  dispatchClearTollLiquidationDifferenceReasons:
    clearTollLiquidationDifferenceReasons,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TollLiquidationDifferenceReasonFilter);
